import {
  CATEGORY_BULK_UPLOAD,
  CATEGORY_CSV_SAMPLE,
  CATEGORY_DROPDOWN_URL,
  CREATE_CATEGORY_URL,
  DELETE_CATEGORY_URL,
  LIST_CATEGORY_URL,
  SINGLE_CATEGORY_URL,
  ACTIVE_CATEGORY,
  USED_MUSEUM_LIST,
  CATEGORY_PHOTO_SETUP,
  CREATE_SUB_CATEGORY_URL,
  SUB_CATEGORY_DROPDOWN_URL,
  LIST_SUB_CATEGORY_URL,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createCategory = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_CATEGORY_URL, props?.payload)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response.data);
      });
  } catch (error) {}
};

export const createSubCategory = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_SUB_CATEGORY_URL, props?.newValuesForSubcategoryEdit)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response.data);
      });
  } catch (error) {}
};

export const listCategory = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_CATEGORY_URL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.sort) {
      BASE_URL += "sort_by=" + props.sort + "&";
    }
    if (props?.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props?.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props?.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.is_key) {
      BASE_URL += "is_key=" + props.is_key + "&";
    }
    if (props?.museum) {
      BASE_URL += "museum=" + props.museum + "&";
    }
    if (props?.not_used_category) {
      BASE_URL += "not_used_category=" + props.not_used_category + "&";
    }
    if (props?.is_primary) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listSubCategory = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_SUB_CATEGORY_URL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.sort) {
      BASE_URL += "sort_by=" + props.sort + "&";
    }

    if (props?.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props?.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.is_key) {
      BASE_URL += "is_key=" + props.is_key + "&";
    }
    if (props?.museum) {
      BASE_URL += "museum=" + props.museum + "&";
    }
    if (props?.not_used_category) {
      BASE_URL += "not_used_category=" + props.not_used_category + "&";
    }
    if (props?.is_primary) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    }
    if (props?.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) {}
};

export const getSingleCategory = (props) => (onResponse) => {
  try {
    let BASE_URL = SINGLE_CATEGORY_URL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
export const deleteCategory = (props) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_CATEGORY_URL, { data: { id: props?.id } })
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listCategoryDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = CATEGORY_DROPDOWN_URL + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.primary_category_missing) {
      BASE_URL +=
        "primary_category_missing=" + props.primary_category_missing + "&";
    }
    if (props.is_primary) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    } else if (props.is_primary === false) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    }
    if (props.is_unique_required) {
      BASE_URL += "is_unique_required=" + props.is_unique_required + "&";
    }
    if (props.transit_location) {
      BASE_URL += "transit_location=" + props.transit_location + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listSubCategoryDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = SUB_CATEGORY_DROPDOWN_URL + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.primary_category_missing) {
      BASE_URL +=
        "primary_category_missing=" + props.primary_category_missing + "&";
    }
    if (props.is_primary) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    } else if (props.is_primary === false) {
      BASE_URL += "is_primary=" + props.is_primary + "&";
    }
    if (props.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    if (props.transit_location) {
      BASE_URL += "transit_location=" + props.transit_location + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) {}
};

export const uploadBulkCategoryHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CATEGORY_BULK_UPLOAD, props?.values)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
export const activeinactivehandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(ACTIVE_CATEGORY, props)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const bulksampledownloadhandler = (props) => (onResponse) => {
  try {
    let BASE_URL = CATEGORY_CSV_SAMPLE + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.file_type) {
      BASE_URL += "file_type=" + props.file_type + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const categoryUsedMuseumlist = (props) => (onResponse) => {
  console.log(props, "propssss");

  try {
    let BASE_URL = USED_MUSEUM_LIST + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.category_id) {
      BASE_URL += "category_id=" + props.category_id + "&";
    }
    if (props.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    axiosInstance
      .get(BASE_URL, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const categoryPhotoSetupList = (props) => (onResponse) => {
  console.log(props, "propssss");

  try {
    let BASE_URL = CATEGORY_PHOTO_SETUP + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }

    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    axiosInstance
      .get(BASE_URL, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};
